// extracted by mini-css-extract-plugin
export default {"layout":"DashboardLayout-module__layout__va46Y","content":"DashboardLayout-module__content__HWhTQ","collapsed":"DashboardLayout-module__collapsed__cZmte"};